import revive_payload_client_4sVQNw7RlN from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_9gMxCtyFUG from "/home/runner/work/suwo/suwo/website/node_modules/nuxt-site-config/dist/runtime/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/suwo/suwo/website/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_w2VlvAEcpa from "/home/runner/work/suwo/suwo/website/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.mjs";
import gsapPlugin_HlwIIyl85L from "/home/runner/work/suwo/suwo/website/.nuxt/gsapPlugin.mjs";
import plugin_8SbxDRbG6Y from "/home/runner/work/suwo/suwo/website/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import plugin_client_LcKgStRyi6 from "/home/runner/work/suwo/suwo/website/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import script_YrMPz5ICtR from "/home/runner/work/suwo/suwo/website/node_modules/@nuxtjs/turnstile/dist/runtime/plugins/script.mjs";
import strapi_plugin_35gTOGMBRa from "/home/runner/work/suwo/suwo/website/node_modules/@nuxtjs/strapi/dist/runtime/strapi.plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import auto_animate_XcJE6OGLWh from "/home/runner/work/suwo/suwo/website/plugins/auto_animate.ts";
import initial_load_V4zWj8h8hn from "/home/runner/work/suwo/suwo/website/plugins/initial_load.ts";
import markdown_nljPFoZ1ix from "/home/runner/work/suwo/suwo/website/plugins/markdown.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_9gMxCtyFUG,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_w2VlvAEcpa,
  gsapPlugin_HlwIIyl85L,
  plugin_8SbxDRbG6Y,
  plugin_client_LcKgStRyi6,
  script_YrMPz5ICtR,
  strapi_plugin_35gTOGMBRa,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  auto_animate_XcJE6OGLWh,
  initial_load_V4zWj8h8hn,
  markdown_nljPFoZ1ix
]